import { API } from "../auth/authApi";

export const getMasterDataApi = () => {
    return API.get("/master");
};